import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateInvoicePDF = (invoice) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;

  // Add company header
  doc.setFontSize(16);
  doc.text(invoice.from.name, 20, 20);
  
  doc.setFontSize(10);
  doc.text(invoice.from.address, 20, 30);
  doc.text(invoice.from.city, 20, 35);
  doc.text(invoice.from.phone, 20, 40);
  doc.text(invoice.from.email, 20, 45);

  // Add invoice title
  doc.setFontSize(24);
  doc.text('INVOICE', pageWidth - 20, 30, { align: 'right' });
  
  doc.setFontSize(12);
  doc.text(`Invoice #: ${invoice.id}`, pageWidth - 20, 40, { align: 'right' });
  doc.text(`Date: ${invoice.date}`, pageWidth - 20, 45, { align: 'right' });

  // Add status
  doc.setFontSize(12);
  const status = invoice.status.toUpperCase();
  doc.setTextColor(status === 'PAID' ? '#22c55e' : '#f59e0b');
  doc.text(status, pageWidth - 20, 50, { align: 'right' });
  doc.setTextColor(0, 0, 0); // Reset to black

  // Add client information
  doc.setFontSize(11);
  doc.text('Bill To:', 20, 70);
  doc.text(invoice.client, 20, 80);
  doc.text(invoice.jobSite, 20, 85);
  doc.text(`Project Code: ${invoice.jobCode}`, 20, 90);

  // Add line items table
  const tableData = invoice.lineItems.map(item => [
    item.description,
    item.jobCode,
    item.hours,
    `$${item.rate}`,
    `$${item.amount}`
  ]);

  doc.autoTable({
    startY: 100,
    head: [['Description', 'Job Code', 'Hours', 'Rate', 'Amount']],
    body: tableData,
    foot: [[
      'Total',
      '',
      '',
      '',
      `$${invoice.lineItems
        .reduce((sum, item) => sum + parseFloat(item.amount.replace(',', '')), 0)
        .toFixed(2)}`
    ]],
    headStyles: {
      fillColor: [37, 99, 235], // Bootstrap primary color
      textColor: 255,
      fontSize: 11
    },
    footStyles: {
      fillColor: [241, 245, 249], // Light gray
      textColor: 0,
      fontSize: 11,
      fontStyle: 'bold'
    },
    theme: 'grid',
    margin: { left: 20, right: 20 },
    columnStyles: {
      0: { cellWidth: 'auto' },
      1: { cellWidth: 30 },
      2: { cellWidth: 25, halign: 'right' },
      3: { cellWidth: 30, halign: 'right' },
      4: { cellWidth: 30, halign: 'right' }
    }
  });

  // Add footer
  const finalY = doc.lastAutoTable.finalY || 150;
  doc.setFontSize(10);
  doc.text('Thank you for your business!', pageWidth / 2, finalY + 20, { align: 'center' });

  return doc;
}; 